import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UISyncService {
  // internal BehaviorSubject holds the current label
  private _selectedRouteLabel$ = new BehaviorSubject<string>('Dashboard');

  // observable consumers can subscribe or use async pipe
  selectedRouteLabel$ = this._selectedRouteLabel$.asObservable();

  // legacy/template-friendly getter (keeps existing template usages like uiService.selectedRouteLabel)
  get selectedRouteLabel(): string {
    return this._selectedRouteLabel$.value;
  }

  // allow assignment as before (sidebar was assigning uiService.selectedRouteLabel = label)
  set selectedRouteLabel(label: string) {
    this._selectedRouteLabel$.next(label);
  }
}
